/* @ngInject */
export function ServiceContractsController($log, NavigationService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        $log.debug('ServiceContracts::init');
        var navConfig = NavigationService.getNavConfig();
        ctrl.colorName = navConfig.colorName;
        ctrl.icon = navConfig.icon;
    };
}
